// Types
import { TYPES } from "../types/types.constants";

// Services
import { VirtualCredentialService, StorageService } from '../../services';

// Actions
import { setErrorAction, setGoNoGoAction, setLoadingAction } from './app.action';
import { activatedBenefitAction } from "./benefit.action";

// Constants
import { APP_CONFIG } from "../../constants";

// Mappers
import { ConfigMapper, TransactionMapper } from '../../mappers';

// Helpers
import { sendEventDetailPage } from "../../helpers";

/**
 * Crea una nueva transacción y la pone activa a partir de la información escaneada
 * @param {Object} data Información de la transacción
 * @param {Object} pageConfig Configuración de la página que genera la acción
 * @param {Function} loading Referencia a función para mostrar el loading
 */
export const startCreateTransactionAction = (data, pageConfig, loading, history) => {

    return async (dispatch) => {

        try {

            loading(true);

            let transactionData;
            let pageInit = StorageService.load(APP_CONFIG.STORAGE.KEYS.PAGE_INIT);

            if (pageInit === APP_CONFIG.PAGES.DOCUMENT.path) {

                transactionData = { ...data, source: "DNI" }
            }
            if (pageInit === APP_CONFIG.PAGES.QR_SCAN.path) {

                transactionData = { ...data, source: "QR" }
            }

            window?.DD_LOGS?.logger && window.DD_LOGS.logger.info({transactionData});
            const transaction = await VirtualCredentialService.create(transactionData);
            if (Object.keys(APP_CONFIG.API.VIRTUAL_CREDENTIAL.INVALID_CODE).map(code => Number(code)).includes(transaction.transactionStatus)) {

                if (transaction.transactionStatus === 205) {

                    APP_CONFIG.API.VIRTUAL_CREDENTIAL.INVALID_CODE[transaction.transactionStatus].MESSAGE = APP_CONFIG.API.VIRTUAL_CREDENTIAL.INVALID_CODE[transaction.transactionStatus].MESSAGE.replace('[X]', transaction.subscriber.program.description);
                }

                throw new Error(APP_CONFIG.API.VIRTUAL_CREDENTIAL.INVALID_CODE[transaction.transactionStatus].MESSAGE);
            }

            dispatch(activatedAction(transaction));
            dispatch(activatedBenefitAction({ benefitId: data.benefitId }));
            history.push(pageConfig.nextPage);

        } catch (error) {
            dispatch(setErrorAction(error));
        }
        finally {

            loading(false);
        }
    };
};

/**
 * Actualiza una transacción y la deja activada
 * @param {Object} transaction Transacción para ser actualizada
 * @param {Function} loading Referencia a función para mostrar el loading
 */
export const startUpdateTransactionAction = (transaction, loading) => {

    return async (dispatch) => {

        try {

            loading(true);

            let transactionUpdated = await VirtualCredentialService.update(transaction.transactionId, transaction);
            transactionUpdated.approved = transaction.transactionStatus === APP_CONFIG.API.VIRTUAL_CREDENTIAL.APPROVED_CODE;

            dispatch(updateAction(transaction.transactionId, transactionUpdated));

            // Analytics
            transactionUpdated.approved ?
                sendEventDetailPage(APP_CONFIG.ANALYTICS.EVENTS.DETAIL_PAGE.ACTIONS.CONFIRM) :
                sendEventDetailPage(APP_CONFIG.ANALYTICS.EVENTS.DETAIL_PAGE.ACTIONS.CANCEL);

        } catch (error) {

            dispatch(setErrorAction(error));
        }
        finally {

            loading(false);
        }
    };
};

/**
 * Obtiene un listado de transacciones de manera paginada
 * @param {Object} params Parámetros de consulta
 * @param {Object} pagination Información del paginado
 * @param {Function} loading Referencia a función para mostrar el loading
 */
export const startListTransactionsAction = (params, pagination, loading) => {

    return async (dispatch, getState) => {

        try {

            loading(true);

            const { list } = getState().transaction;
            if (pagination.page > 1 && list.metadata.nextKey !== undefined) {

                params['updatedDate'] = list.metadata.nextKey?.updatedDate;
                params['transactionId'] = list.metadata.nextKey?.transactionId;
            }

            const { data: transactions, metadata } = await VirtualCredentialService.list(params, pagination);
            dispatch(listAction(transactions, metadata));

            if (metadata.nextKey === null && pagination.page > 1) {
                throw new Error(APP_CONFIG.PAGES.HISTORY.messages.error.emptyResult);
            }


        } catch (error) {

            dispatch(setErrorAction(error));
        }
        finally {

            loading(false);
        }
    };
};

/**
 * Obtiene una transacción por su identificador, y la activa
 * @param {String} transactionId Id de transacción
 * @param {Function} loading Referencia a función para mostrar el loading
 */
export const startGetTransactionAction = (transactionId, pageConfig, loading, history) => {

    return async (dispatch) => {

        try {

            loading(true);

            const transaction = await VirtualCredentialService.get(transactionId);
            if (transaction === undefined) { throw new Error(APP_CONFIG.PAGES.DETAIL.messages.error.notFoundTransaction); };

            dispatch(resetTransactionAction());
            dispatch(activatedAction(transaction));
            history.push(pageConfig.nextPage);

        } catch (error) {

            dispatch(setErrorAction(error));
        }
        finally {

            loading(false);
        }

    };
};

/**
 * Obtiene la configuración del GONOGO
 */
export const startGetSettingAction = () => {

    return async (dispatch) => {

        try {

            const settings = await VirtualCredentialService.getSettings();
            if (settings === undefined) {

                return;
            };

            StorageService.save(APP_CONFIG.STORAGE.KEYS.USER, settings.userData);

            ConfigMapper.replaceInfoConfig(settings);
            dispatch(setGoNoGoAction(settings));

        } catch (error) {

            // console.log(error);
            // console.error("Error en obtencion archivo gonogo");
            // dispatch(setErrorAction("Error en obtencion archivo gonogo"));
        }

    };
};

/**
 * Obtiene la metadata de las transacciones
 */
export const startGetTransactionMetadataAction = () => {

    return async (dispatch) => {

        try {

            dispatch(setLoadingAction(true));

            let { data, files } = await VirtualCredentialService.getTransactionMetadata();
            const infoFiles = TransactionMapper.transformFileInfo( files );

            dispatch(setMetadataAction({...data[0], files: infoFiles }));

        } catch (error) {

            dispatch(setErrorAction(error));
        }
        finally {

            dispatch(setLoadingAction(false));
        }

    };
};

/**
 * Setea la información para la transacción
 * @param {Object} transaction Información del scaneado
 */
export const setEntityAction = (transaction) => {

    return {

        type: TYPES.TRANSACTION.SET_ENTITY,
        payload: {
            ...transaction
        }
    };
};

/**
 * Setea la metadata de transacciones para mostrar en la home
 * @param {Object} transactionMetadata Metadata de la transaccion
 */
export const setMetadataAction = (transactionMetadata) => {

    return {

        type: TYPES.TRANSACTION.METADATA,
        payload: {
            ...transactionMetadata
        }
    };
};

/**
 * Setea una transacción a estado activo
 * @param {Object} transaction Transacción para activar
 */
export const activatedAction = (transaction) => {

    return {

        type: TYPES.TRANSACTION.ACTIVATED,
        payload: {
            ...transaction
        }
    };
};

/**
 * Actualiza una transacción y actualiza el listado de transacciones
 * @param {string} transactionId Id de la transacción
 * @param {Object} transaction Transacción para actualizar
 */
export const updateAction = (transactionId, transaction) => {

    return {

        type: TYPES.TRANSACTION.UPDATE,
        payload: {
            transactionId,
            ...transaction
        }
    };
};

/**
 * Setea el listado de transacciones
 * @param {Array Object} transactions Transacciones obtenidas
 * @param {Object} metadata Metadata para el paginado
 */
export const listAction = (transactions, metadata) => {

    return {

        type: TYPES.TRANSACTION.LIST,
        payload: {
            transactions,
            metadata
        }
    };
};

/**
 * Vuelve al estado inicial la información de las transacciones
 */
export const resetTransactionAction = () => {

    return {

        type: TYPES.TRANSACTION.RESET
    };
};